import { formatSeconds } from '@/utils/time'
import { timetransition } from './common'
// 该库用于将数据转换为Echart兼容的格式
const yAxisDefault = {
  splitLine: { show: false },
  minInterval: 1,
  axisLine: {
    lineStyle: {
      color: '#5e859e', // 纵坐标轴和字体颜色
      width: 2
    }
  }
}
// 将坐标点抽离
export const formatXY = function (data) {
  const result = {}
  ;(data || []).forEach(item => {
    Object.keys(item).forEach(key => {
      if (!result[key]) {
        result[key] = [item[key]]
      } else {
        result[key].push(item[key])
      }
    })
  })
  return result
}

// config :{ yAxis:{name:$t('integration.number_of_exceptions')} ,series:{name:$t('integration.abnormal_duration'),type:'bar'} }
export const formatEchart = function (data, config = {}) {
  const formated = formatXY(data)
  // 结构X轴  X轴的键是固定的
  const { xAxis } = formated
  // echart 转换结果对象
  const result = {}
  result.xAxis = xAxis
  result.yAxis = []
  result.series = []
  Object.keys(config).forEach(key => {
    const yAxis = formated[key]

    result.series.push({
      data: yAxis || [],
      ...config[key]
    })

    // 定义y轴
    result.yAxis.push({
      type: 'value',
      name: config[key].name,
      axisLabel: {
        formatter: config[key].formatter || '{value}'
      },
      ...yAxisDefault
    })
  })
  result.rest = {
    isShow: true
  }
  return result
}

export const tooltipMinFormat = function formatter (params) {
  let result = null
  if (params.componentSubType === 'pie') {
    result = params.seriesName + '<br>'
    result +=
      params.marker +
      `<span>${
        params.name
      }</span><span class='uk-margin-small-left bolder'>${formatSeconds(
        params.value * 60
      )}</span><br>`
  } else {
    result = params[0].axisValue + '<br>'
    params.forEach(item => {
      result +=
        item.marker +
        `<span>${
          item.seriesName
        }</span><span class='uk-margin-small-left bolder'>
                    ${
                      item.seriesType === 'bar'
                        ? formatSeconds(item.value * 60)
                        : item.value
                    }</span><br>`
    })
  }
  return result
}

// 数据拆分 将一条折线图拆分成多条  方便用户看出上面时间段传感器断开
export const breakPoint = function (echatItem = {}, interval = 300000) {
  const data = echatItem.data
  // 浅拷贝data
  const result = [...data]

  // 让时间看上去更加平滑 计算一个平均的时间值
  let avgInterval = 0
  // 全局插入计数器  每次插入都会产生偏移
  let insertCount = 0
  for (let i = 1; i < data.length; i++) {
    // 当前对比上一条 时间做X轴
    const timeInterval =
      new Date(data[i].name).getTime() - new Date(data[i - 1].name).getTime()
    if (timeInterval > interval + 60 * 1000) {
      // 计算中间需要模拟出几个点 四舍五入  并且避免平均值为interval避免陷入死循环
      // const pointNums = parseInt(timeInterval / ((avgInterval || timeInterval) + 1));
      const pointNums = parseInt(timeInterval / interval)
      // 记录上一个时间点
      let lastTimePoint = data[i - 1]
      // j相当于局部偏移  构建点
      for (let j = 0; j < pointNums; j++) {
        // 拷贝一份 再修改里面的数据
        const item = JSON.parse(JSON.stringify(data[i]))
        // 欲写入时间点
        const time = new Date(lastTimePoint.name).getTime() + interval
        item.name = timetransition(time)
        // 设置xy轴
        item.value = [item.name, '---']
        result.splice(i + insertCount + j, 0, item)

        // 上一个时间点设置未自身
        lastTimePoint = item

        if (j === pointNums - 1) {
          insertCount += pointNums
        }
      }
    } else {
      // 在间隔没有超出的情况下平均填充点
      if (avgInterval) {
        avgInterval = Math.floor((avgInterval + timeInterval) / 2)
      } else {
        avgInterval = timeInterval
      }
    }
  }
  echatItem.data = result

  return echatItem
}

/**
 * 使用服务器返回的数据 生成echart分段配置 以区分是否存储帧 是否超出监测区间
 * @param data 服务器返回的数据
 * @param range 监测区间
 */
export const markStore = (data, range) => {
  const colorMap = {
    // 正常帧 (实时帧)
    normal: '#344962',
    // 存储帧
    store: 'orange',
    // 超出监测区间
    outRange: 'red'
  }
  const chartPieces = []
  // 开始 结束指针
  let start = 0
  if (data instanceof Array) {
    if (data.length && data[0].isStore === undefined) {
      return [
        {
          gte: 0,
          lte: new Date().getTime(),
          color: '#344962'
        }
      ]
    }
    data.forEach((item, index) => {
      const time = item.sampleTime || item.collectTime

      if (item.isStore !== data[index + 1]?.isStore) {
        chartPieces.push({
          gte: start,
          lte: time,
          color: item.isStore ? colorMap.store : colorMap.normal
        })
        start = time
      }
    })
  }
  return chartPieces
}

/**
 * 计算Y轴的最大最小值 如果监测区间的值比最小值小 则返回监测区间值 反之亦然
 * 因为折线图要将监测区间和整条折线图全部呈现...
 * @param data 服务器返回的数据 经过这三个值计算rangeData:[],maxVal:number,minVal:number
 */
export const calcYAxisMinMax = data => {
  const { rangeData, maxVal, minVal } = data
  let min = minVal
  let max = maxVal
  rangeData.forEach(item => {
    if (item.minVal < min) {
      min = item.minVal - 5
    }
    if (item.maxVal > max) {
      max = item.maxVal + 5
    }
  })
  return {
    min,
    max
  }
}
